
import React from 'react'
import { Container, Typography, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/**
 * Header component for public pages
 * Provides consistent header layout with logo and navigation
 */
const PublicPageHeader = ({
  logo = '/images/LeftNavLogo.png',
  title = 'General',
  subtitle = 'bamburgh',
  navigation = [],
  actions = [],
  className = '',
  style = {},
  ...props
}) => {
  return (
    <Box sx={{ pb: '1rem' }}>
      <Container>
        <Box
          sx={{
            borderRadius: '0.65rem',
            minHeight: 84,
            alignItems: 'center',
            display: 'flex',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              component="a"
              href="/"
              onClick={(e) => e.preventDefault()}
              title="Housefolios"
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  borderRadius: '0.29rem',
                  width: 40,
                  height: 40,
                  backgroundColor: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  boxShadow: '1px 1px 3px rgba(7, 9, 25, 0.2)',
                  '& img': { width: 26, margin: '0 auto' },
                }}
              >
                <img alt="Housefolios" src={logo} />
              </Box>
              <Box
                sx={{
                  lineHeight: 1,
                  pl: '0.667rem',
                  color: '#fff',
                }}
              >
                <span>{title}</span>
                <b>{subtitle}</b>
              </Box>
            </Box>
          </Box>

          {navigation.length > 0 && (
            <Box
              sx={{
                display: 'none',
                '@media (min-width: 1100px)': { display: 'block' },
              }}
            >
              <Box
                component="ul"
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                {navigation.map((item, index) => (
                  <li key={index}>
                    <Box
                      component="a"

                      href={item.href || '#/'}
                      onClick={(e) => {
                        e.preventDefault()
                        if (item.onClick) item.onClick()
                      }}
                      sx={{ borderRadius: '0.29rem' }}
                    >
                      {item.label}
                      {item.hasDropdown && (
                        <Box component="span" sx={{ opacity: "0.5 !important" }}>
                          <FontAwesomeIcon
                            icon={['fas', 'angle-down']}
                          />
                        </Box>
                      )}
                    </Box>
                    {item.dropdown && (
                      <div>
                        {item.dropdown}
                      </div>
                    )}
                  </li>
                ))}
              </Box>
            </Box>
          )}

          {actions.length > 0 && (
            <Box
              sx={{
                flexGrow: 0,
                '@media (min-width: 1100px)': { flexGrow: 1 },
              }}
            >
              {actions.map((action, index) => (
                <Box
                  key={index}
                  component="span"
                  className={action.className || ''}
                  sx={action.sx}
                >
                  {action.component}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  )
}

export default PublicPageHeader
